import { render, staticRenderFns } from "./UserIncubatorList.vue?vue&type=template&id=522d2b03"
import script from "./UserIncubatorList.vue?vue&type=script&lang=js"
export * from "./UserIncubatorList.vue?vue&type=script&lang=js"
import style0 from "./UserIncubatorList.vue?vue&type=style&index=0&id=522d2b03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports